// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"042716b3","879":"62c2669d"}[chunkId] + ".chunk.js";
};